var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-cl-white body-box" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "columns is-marginless is-paddingless is-centered bd-rd-4px"
      },
      [
        _c(
          "div",
          { staticClass: "column is-4" },
          [
            _vm._l(_vm.printers, function(printer, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "printer mg-10px pd-6px f-w-bold t-al-center cs-pointer",
                  on: {
                    click: function($event) {
                      _vm.finishPrint(printer.ip)
                    }
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(printer.name) + " "),
                  _c("br"),
                  _vm._v(" " + _vm._s(printer.ip) + "\n      ")
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "no-print mg-10px pd-18px f-w-bold cs-pointer",
                on: {
                  click: function($event) {
                    _vm.finishPrint("no print")
                  }
                }
              },
              [_vm._v("\n        ไม่พิมพ์ใบเสร็จ\n      ")]
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-100pct h-60px bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center"
      },
      [_c("span", [_vm._v("\n      พิมพ์ใบเสร็จ\n    ")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4516a6f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4516a6f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/check-out/components/SelectPrinter.vue
// module id = 493
// module chunks = 1